import React from 'react';
import { Bot, Lock, Unlock, Loader2 } from 'lucide-react';

/**
 * AIAccessIcon
 * - Shows a base AI icon (image) with a lock/unlock badge to indicate access state
 * - When loading, shows a spinner instead
 *
 * Props:
 * - enabled (boolean): whether AI access is enabled
 * - size (number): base icon size in pixels (default 20)
 * - loading (boolean): show spinner
 * - iconSrc (string): optional custom image source for the base icon
 */
const DEFAULT_ICON_SRC = 'https://img.icons8.com/?size=100&id=rnK88i9FvAFO&format=png&color=000000';

const AIAccessIcon = ({ enabled = false, size = 20, loading = false, iconSrc = DEFAULT_ICON_SRC }) => {
  const baseSize = size;
  const badgeSize = Math.max(12, Math.round(size * 0.6));

  if (loading) {
    return (
      <div className="relative inline-flex items-center justify-center" style={{ width: baseSize, height: baseSize }}>
        <Loader2 className="animate-spin" size={baseSize - 2} />
      </div>
    );
  }

  return (
    <div
      className="relative inline-flex items-center justify-center"
      style={{ width: baseSize, height: baseSize }}
      aria-hidden
    >
      {/* Base AI icon image (Gemini) */}
      {iconSrc ? (
        <img
          src={iconSrc}
          alt="AI"
          width={baseSize}
          height={baseSize}
          className="object-contain"
          onError={(e) => {
            // fallback to a Bot icon if image fails
            e.currentTarget.style.display = 'none';
          }}
        />
      ) : (
        <Bot size={baseSize - 2} />
      )}

      {/* Badge */}
      <div
        className={`absolute -right-1 -top-1 rounded-full border border-white flex items-center justify-center ${
          enabled ? 'bg-green-600' : 'bg-yellow-600'
        }`}
        style={{ width: badgeSize / 2, height: badgeSize / 2 }}
      >
        {enabled ? (
          <Unlock className="text-white" size={Math.max(10, Math.round(badgeSize / 3))} />
        ) : (
          <Lock className="text-white" size={Math.max(10, Math.round(badgeSize / 3))} />
        )}
      </div>
    </div>
  );
};

export default AIAccessIcon;
